export const DEFAULT_ANNOUNCEMENT_DELAY = 1000 as const;
